import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";
import css from "../../assets/css/Withdraw.module.css";
import "../../assets/css/layout.css";

// Modern vector icons
import {
  BsArrowLeft,
  BsShieldCheck,
  BsCheck2,
  BsWallet2,
} from "react-icons/bs";
import {
  RiBankLine,
  RiSmartphoneLine,
  RiQrCodeLine,
  RiArrowRightSLine,
  RiInformationLine,
  RiUploadCloud2Line,
  RiUser3Line,
} from "react-icons/ri";
import { FiAlertCircle, FiEdit3 } from "react-icons/fi";

const Withdraw = ({ walletUpdate }) => {
  const history = useHistory();
  const fileInputRef = useRef(null);

  const [user, setUser] = useState();
  const [holder_name, setHolder_name] = useState("");
  const [account_number, setAccount_number] = useState("");
  const [confirm_account_number, setConfirm_account_number] = useState("");
  const [ifsc_code, setIfsc_code] = useState("");
  const [upi_id, setUpi_id] = useState("");
  const [confirm_upi_id, setConfirm_upi_id] = useState("");
  const [next, setNext] = useState(false); // false | 1 (Amount), 2 (Method), 3 (Details)

  const [submitBtn, setSubmitBtn] = useState(true);
  const [withdrawal, setWithdrawal] = useState(true);
  const [qrWithdrawal, setQrWithdrawal] = useState(true);
  const [Upiwithdrawal, setUpiWithdrawal] = useState(true);
  const [Bankwithdrawal, setBankWithdrawal] = useState(true);

  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [minLimit, setMinLimit] = useState(95);
  const [maxLimit, setMaxLimit] = useState(500);
  const [minLimitUpi, setMinLimitUpi] = useState(95);
  const [maxLimitUpi, setMaxLimitUpi] = useState(500);
  const [minLimitBank, setMinLimitBank] = useState(95);
  const [maxLimitBank, setMaxLimitBank] = useState(500);
  const [minLimitQr, setMinLimitQr] = useState(95);
  const [maxLimitQr, setMaxLimitQr] = useState(500);
  const [withdrawMessage, setWithdrawMessage] = useState("");

  const [isLoading, setIsloading] = useState(false);
  const [type, setType] = useState(undefined); // "upi" | "banktransfer" | "qrcode"
  const [withdraw_Qr, setwithdraw_Qr] = useState(null);
  const [qrPreview, setQrPreview] = useState(null);

  const loadSettings = () => {
    try {
      const withdrawsetting = localStorage.getItem("sitSetting");
      if (withdrawsetting && withdrawsetting !== "undefined") {
        const s = JSON.parse(withdrawsetting);
        setWithdrawal(s.isWithdrawal);
        setUpiWithdrawal(s.isUpiWithdrawal);
        setBankWithdrawal(s.isBankWithdrawal);
        setQrWithdrawal(s.isQrWithdrawal);

        setWithdrawMessage(s.withdraw_message);

        setMinLimit(s.withdrawalLimitMin);
        setMaxLimit(s.withdrawalLimitMax);
        setMinLimitUpi(s.withdrawalLimitMinUpi);
        setMaxLimitUpi(s.withdrawalLimitMaxUpi);
        setMinLimitBank(s.withdrawalLimitMinBank);
        setMaxLimitBank(s.withdrawalLimitMaxBank);
        setMinLimitQr(s.withdrawalLimitMinQr);
        setMaxLimitQr(s.withdrawalLimitMaxQr);
      }
    } catch (e) {
      console.error("Error parsing site settings in Withdrawopt:", e);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const meeApi = async () => {
    try {
      let access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest(`me`, "GET", null, headers);

      if (res?.data) {
        setUser(res.data);
        if (res.data.holder_name) setHolder_name(res.data.holder_name);
        if (res.data.account_number) setAccount_number(res.data.account_number);
        if (res.data.confirm_account_number)
          setConfirm_account_number(res.data.account_number);
        if (res.data.ifsc_code) setIfsc_code(res.data.ifsc_code);
        if (res.data.upi_id) {
          setUpi_id(res.data.upi_id);
          setConfirm_upi_id(res.data.upi_id);
        }
      }
    } catch (err) {
      console.error("Error loading user details:", err);
    }
  };

  useEffect(() => {
    meeApi();
  }, []);

  const handlePayment = () => {
    const amt = parseFloat(withdrawAmount);
    if (!amt || isNaN(amt) || amt <= 0) {
      Swal.fire({
        title: "Please Enter Amount",
        text: "Kindly enter a valid withdrawal amount to proceed.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (withdrawal === false) {
      Swal.fire({
        title: "Notice",
        text: "Withdrawal is temporarily disabled.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    if (amt > (user?.withdrawAmount || 0)) {
      Swal.fire({
        title: "Insufficient Balance",
        text: `You have ₹${user?.withdrawAmount || 0} available in your Winning Cash.`,
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const upiEligible =
      Upiwithdrawal && amt >= minLimitUpi && amt <= maxLimitUpi;
    const bankEligible =
      Bankwithdrawal && amt >= minLimitBank && amt <= maxLimitBank;
    const qrEligible = qrWithdrawal && amt >= minLimitQr && amt <= maxLimitQr;

    if (!upiEligible && !bankEligible && !qrEligible) {
      let ranges = [];
      if (Upiwithdrawal) ranges.push(`UPI: ₹${minLimitUpi} - ₹${maxLimitUpi}`);
      if (Bankwithdrawal)
        ranges.push(`Bank: ₹${minLimitBank} - ₹${maxLimitBank}`);
      if (qrWithdrawal) ranges.push(`QR: ₹${minLimitQr} - ₹${maxLimitQr}`);

      Swal.fire({
        title: "Amount Out of Limits",
        text:
          ranges.length > 0
            ? `Allowed withdrawal ranges: ${ranges.join(" | ")}`
            : "No withdrawal channels are currently enabled.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setNext(2);
  };

  const handleIfscChange = (e) => {
    const inputValue = e.target.value.toUpperCase();
    if (inputValue.length <= 11) {
      setIfsc_code(inputValue);
    }
  };

  const handleQrUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setwithdraw_Qr(file);
      setQrPreview(URL.createObjectURL(file));
    }
  };

  const updateBankDetails = async () => {
    setIsloading(true);
    setSubmitBtn(false);

    if (type === "upi") {
      let regex = /^[\w.-]+@[\w.-]+$/.test(upi_id);

      if (regex) {
        if (upi_id === confirm_upi_id) {
          const access_token = localStorage.getItem("token");
          const headers = {
            Authorization: `Bearer ${access_token}`,
          };

          let alldata = {
            holder_name,
            upi_id,
          };
          const res = await apiRequest(
            `user/withdraw/edit`,
            "PATCH",
            alldata,
            headers,
          );
          setIsloading(false);
          if (res?.data?.status === true) {
            withReqComes();
          } else {
            setSubmitBtn(true);
            Swal.fire({
              title: res?.data?.msg || "Failed to update UPI details",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          setIsloading(false);

          setSubmitBtn(true);
          Swal.fire({
            title: "UPI IDs Do Not Match",
            text: "Please make sure both UPI IDs match exactly.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        setIsloading(false);

        setSubmitBtn(true);
        Swal.fire({
          title: "Invalid UPI ID",
          text: `Please enter a valid UPI ID (e.g. mobile@upi, username@oksbi).`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else if (type === "banktransfer") {
      if (
        !holder_name ||
        !account_number ||
        !confirm_account_number ||
        !ifsc_code
      ) {
        setIsloading(false);

        setSubmitBtn(true);
        Swal.fire({
          title: "Missing Details",
          text: "Please fill all bank account fields.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      if (account_number !== confirm_account_number) {
        setIsloading(false);

        setSubmitBtn(true);
        Swal.fire({
          title: "Account Number Mismatch",
          text: "Account number and confirm account number do not match.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      let alldata = {
        holder_name,
        account_number,
        confirm_account_number,
        ifsc_code,
      };
      const res = await apiRequest(
        `user/withdraw/edit`,
        "PATCH",
        alldata,
        headers,
      );

      setIsloading(false);

      if (res?.data?.status === true) {
        withReqComes();
      } else {
        setSubmitBtn(true);
        Swal.fire({
          title: res?.data?.msg || "Failed to update bank details",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else if (type === "qrcode") {
      if (!withdraw_Qr) {
        setIsloading(false);

        setSubmitBtn(true);
        Swal.fire({
          title: "QR Code Required",
          text: "Please upload your QR Code image for withdrawal.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      const formData = new FormData();

      formData.append("amount", withdrawAmount);
      formData.append("type", type);
      formData.append("withdraw_Qr", withdraw_Qr);

      try {
        const res = await apiRequest(
          "withdraw/request",
          "POST",
          formData,
          headers,
        );

        setIsloading(false);

        if (res.data.success) {
          if (walletUpdate) walletUpdate();
          Swal.fire({
            title: "Success",
            text:
              res?.data?.msg || "Withdrawal request submitted successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });
          history.push("/");
        } else {
          setSubmitBtn(true);
          Swal.fire({
            title: "Error",
            text: res.data.msg || "Withdrawal request failed",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (err) {
        setIsloading(false);

        setSubmitBtn(true);
        Swal.fire({
          title: "Request Error",
          text: "Something went wrong while submitting withdrawal request.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const withReqComes = async () => {
    try {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const checkAmt = parseFloat(withdrawAmount);
      let curMin = minLimit;
      let curMax = maxLimit;
      if (type === "upi") {
        curMin = minLimitUpi;
        curMax = maxLimitUpi;
      } else if (type === "banktransfer") {
        curMin = minLimitBank;
        curMax = maxLimitBank;
      } else if (type === "qrcode") {
        curMin = minLimitQr;
        curMax = maxLimitQr;
      }

      if (checkAmt < curMin || checkAmt > curMax) {
        setSubmitBtn(true);
        setIsloading(false);
        Swal.fire({
          title: "Invalid amount",
          text: `Please enter an amount between ₹${curMin} and ₹${curMax}.`,
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      let alldata = {
        holder_name,
        type,
        account_number,
        confirm_account_number,
        ifsc_code,
        upi_id,
        bankDetails: true,
        amount: withdrawAmount,
      };

      const res = await apiRequest(
        `withdraw/request`,
        "POST",
        alldata,
        headers,
      );

      setIsloading(false);

      if (res?.data?.success) {
        if (walletUpdate) walletUpdate();
        Swal.fire({
          title: "Withdrawal Requested!",
          text: res?.data?.msg || "Your withdrawal request has been received.",
          icon: "success",
          confirmButtonText: "OK",
        });
        history.push("/");
      } else {
        setSubmitBtn(true);
        Swal.fire({
          title: "Error",
          text: res?.data?.msg || "Could not process withdrawal request.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setIsloading(false);

      setSubmitBtn(true);
      Swal.fire({
        title: "Error",
        text: "Network or server error during withdrawal request.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleBackNavigation = () => {
    if (next === 3) {
      setNext(2);
    } else if (next === 2) {
      setNext(false);
      setType(undefined);
    } else {
      history.goBack();
    }
  };

  const currentStep = !next ? 1 : next === 2 ? 2 : 3;

  return (
    <div
      className="leftContainer page_layout"
      style={{ backgroundColor: "#f8fafc" }}
    >
      <div className={css.pageWrapper}>
        {/* Top Navigation Bar */}
        <div className={css.topNav}>
          <button
            type="button"
            className={css.navBackBtn}
            onClick={handleBackNavigation}
            title="Go Back"
          >
            <BsArrowLeft />
          </button>
          <h2 className={css.navTitle}>Withdraw Funds</h2>
          <div className={css.navBalanceBadge}>
            <BsWallet2 />
            <span>₹{user ? user?.withdrawAmount : 0}</span>
          </div>
        </div>

        {/* Hero Balance Card */}
        <div className={css.heroBalanceCard}>
          <span className={css.heroLabel}>Withdrawable Winning Cash</span>
          <h1 className={css.heroAmount}>₹{user ? user?.withdrawAmount : 0}</h1>
          <div className={css.heroMeta}>
            <div className={css.heroMetaItem}>
              <span>Total Balance:</span>
              <span className={css.heroMetaVal}>
                ₹{user ? user?.Wallet_balance : 0}
              </span>
            </div>
            <div className={css.heroMetaItem}>
              <BsShieldCheck color="#10b981" />
              <span>Instant Payouts 24x7</span>
            </div>
          </div>
        </div>

        {/* Withdrawal Notice / Announcement */}
        {withdrawMessage && (
          <div className={css.noticeBanner}>
            <RiInformationLine />
            <span>{withdrawMessage}</span>
          </div>
        )}

        {/* KYC Verification Guard */}
        {user && user?.verified === "unverified" && (
          <Link to="/profile" className={css.kycAlertCard}>
            <div className={css.kycAlertIcon}>
              <FiAlertCircle />
            </div>
            <div className={css.kycAlertContent}>
              <div className={css.kycAlertTitle}>KYC Verification Required</div>
              <p className={css.kycAlertDesc}>
                Please complete your identity KYC verification in your profile
                to unlock withdrawals.
              </p>
              <span className={css.kycAlertAction}>Complete KYC Now →</span>
            </div>
          </Link>
        )}

        {user && user?.verified === "reject" && (
          <Link to="/profile" className={css.kycAlertCard}>
            <div className={css.kycAlertIcon}>
              <FiAlertCircle />
            </div>
            <div className={css.kycAlertContent}>
              <div className={css.kycAlertTitle}>KYC Was Rejected</div>
              <p className={css.kycAlertDesc}>
                Your previous KYC submission was not approved. Please re-upload
                your valid government ID.
              </p>
              <span className={css.kycAlertAction}>Re-submit KYC →</span>
            </div>
          </Link>
        )}

        {user && user?.verified === "pending" && (
          <div className={css.kycAlertCard}>
            <div
              className={css.kycAlertIcon}
              style={{ color: "#0284c7", background: "#f0f9ff" }}
            >
              <RiInformationLine />
            </div>
            <div className={css.kycAlertContent}>
              <div className={css.kycAlertTitle} style={{ color: "#0369a1" }}>
                KYC Under Review
              </div>
              <p className={css.kycAlertDesc}>
                Your KYC documents are currently being processed. Withdrawals
                will be enabled once approved.
              </p>
            </div>
          </div>
        )}

        {user && user?.Email === null && user?.verified === "verified" && (
          <Link to="/profile" className={css.kycAlertCard}>
            <div className={css.kycAlertIcon}>
              <FiAlertCircle />
            </div>
            <div className={css.kycAlertContent}>
              <div className={css.kycAlertTitle}>
                Email Verification Required
              </div>
              <p className={css.kycAlertDesc}>
                Please update and verify your email address to enable
                withdrawals.
              </p>
              <span className={css.kycAlertAction}>Verify Email →</span>
            </div>
          </Link>
        )}

        {/* Main Withdrawal Flows when User is Verified */}
        {user && user?.verified === "verified" && user?.Email !== null && (
          <>
            {/* Visual Stepper */}
            <div className={css.stepperWrapper}>
              <div className={css.stepperLine}>
                <div
                  className={css.stepperLineFill}
                  style={{
                    width:
                      currentStep === 1
                        ? "0%"
                        : currentStep === 2
                          ? "50%"
                          : "100%",
                  }}
                ></div>
              </div>

              {/* Step 1 */}
              <div
                className={`${css.stepItem} ${
                  currentStep === 1
                    ? css.stepActive
                    : currentStep > 1
                      ? css.stepDone
                      : ""
                }`}
              >
                <div className={css.stepCircle}>
                  {currentStep > 1 ? <BsCheck2 /> : "1"}
                </div>
                <span className={css.stepLabel}>Amount</span>
              </div>

              {/* Step 2 */}
              <div
                className={`${css.stepItem} ${
                  currentStep === 2
                    ? css.stepActive
                    : currentStep > 2
                      ? css.stepDone
                      : ""
                }`}
              >
                <div className={css.stepCircle}>
                  {currentStep > 2 ? <BsCheck2 /> : "2"}
                </div>
                <span className={css.stepLabel}>Method</span>
              </div>

              {/* Step 3 */}
              <div
                className={`${css.stepItem} ${
                  currentStep === 3 ? css.stepActive : ""
                }`}
              >
                <div className={css.stepCircle}>3</div>
                <span className={css.stepLabel}>Details</span>
              </div>
            </div>

            {/* STEP 1: ENTER AMOUNT */}
            {Boolean(!next) && (
              <div className={css.cardBox}>
                <div className={css.cardBoxHeader}>
                  <div className={css.cardBoxTitle}>
                    Enter Withdrawal Amount
                  </div>
                  <p className={css.cardBoxSubtitle}>
                    Choose an amount or pick a quick chip below
                  </p>
                </div>

                <div className={css.amountInputWrapper}>
                  <span className={css.currencySymbol}>₹</span>
                  <input
                    type="number"
                    className={css.amountInput}
                    placeholder="0"
                    value={withdrawAmount}
                    onChange={(e) => setWithdrawAmount(e.target.value)}
                    autoFocus
                  />
                </div>

                {/* Quick Amount Chips */}
                <div className={css.chipsGrid}>
                  {[100, 200, 500, 1000].map((val) => (
                    <button
                      key={val}
                      type="button"
                      className={`${css.chipBtn} ${
                        parseFloat(withdrawAmount) === val
                          ? css.chipBtnActive
                          : ""
                      }`}
                      onClick={() => setWithdrawAmount(val.toString())}
                    >
                      + ₹{val}
                    </button>
                  ))}
                  <button
                    type="button"
                    className={`${css.chipBtn} ${
                      parseFloat(withdrawAmount) === 2000
                        ? css.chipBtnActive
                        : ""
                    }`}
                    onClick={() => setWithdrawAmount("2000")}
                  >
                    + ₹2000
                  </button>
                  <button
                    type="button"
                    className={`${css.chipBtn} ${css.chipBtnMax}`}
                    onClick={() =>
                      setWithdrawAmount((user?.withdrawAmount || 0).toString())
                    }
                    title="Withdraw all winnings"
                  >
                    Max (₹{user?.withdrawAmount || 0})
                  </button>
                </div>

                {/* Available Limits Summary */}
                <div className={css.limitsSummary}>
                  <div className={css.limitsSummaryTitle}>Available Limits</div>
                  <div className={css.limitsTagsWrap}>
                    {Upiwithdrawal && (
                      <span className={css.limitTag}>
                        UPI: ₹{minLimitUpi} - ₹{maxLimitUpi}
                      </span>
                    )}
                    {Bankwithdrawal && (
                      <span className={css.limitTag}>
                        Bank: ₹{minLimitBank} - ₹{maxLimitBank}
                      </span>
                    )}
                    {qrWithdrawal && (
                      <span className={css.limitTag}>
                        QR: ₹{minLimitQr} - ₹{maxLimitQr}
                      </span>
                    )}
                  </div>
                </div>

                <button
                  type="button"
                  className={css.btnPrimary}
                  onClick={handlePayment}
                >
                  <span>Select Payment Method</span>
                  <RiArrowRightSLine style={{ fontSize: "1.2rem" }} />
                </button>
              </div>
            )}

            {/* STEP 2: SELECT PAYMENT METHOD */}
            {next === 2 && (
              <div className={css.cardBox}>
                <div className={css.cardBoxHeader}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div className={css.cardBoxTitle}>
                        Select Withdrawal Channel
                      </div>
                      <p className={css.cardBoxSubtitle}>
                        Withdrawing ₹{withdrawAmount}
                      </p>
                    </div>
                    <button
                      type="button"
                      className={css.btnEditMethod}
                      onClick={() => {
                        setNext(false);
                        setType(undefined);
                      }}
                    >
                      <FiEdit3 className="mr-1" /> Change Amount
                    </button>
                  </div>
                </div>

                <div className={css.methodsList}>
                  {/* Method 1: UPI */}
                  {Upiwithdrawal &&
                    (() => {
                      const isEligible =
                        parseFloat(withdrawAmount) >= minLimitUpi &&
                        parseFloat(withdrawAmount) <= maxLimitUpi;
                      return (
                        <div
                          className={`${css.methodCard} ${
                            !isEligible ? css.methodCardDisabled : ""
                          }`}
                          onClick={() => {
                            if (!isEligible) {
                              Swal.fire({
                                title: "Amount Outside UPI Limits",
                                text: `UPI withdrawals require ₹${minLimitUpi} to ₹${maxLimitUpi}.`,
                                icon: "info",
                                confirmButtonText: "OK",
                              });
                              return;
                            }
                            setType("upi");
                            setNext(3);
                          }}
                        >
                          <div className={css.methodCardLeft}>
                            <div
                              className={`${css.methodIconWrap} ${css.upiIconStyle}`}
                            >
                              <RiSmartphoneLine />
                            </div>
                            <div className={css.methodInfo}>
                              <div className={css.methodName}>UPI Transfer</div>
                              <div className={css.methodDesc}>
                                Instant transfer (30s) • GPay, PhonePe, Paytm
                              </div>
                              <span className={css.methodLimitsPill}>
                                Limit: ₹{minLimitUpi} - ₹{maxLimitUpi}
                              </span>
                            </div>
                          </div>
                          <div className={css.methodCardArrow}>
                            <RiArrowRightSLine />
                          </div>
                        </div>
                      );
                    })()}

                  {/* Method 2: Bank Transfer */}
                  {Bankwithdrawal &&
                    (() => {
                      const isEligible =
                        parseFloat(withdrawAmount) >= minLimitBank &&
                        parseFloat(withdrawAmount) <= maxLimitBank;
                      return (
                        <div
                          className={`${css.methodCard} ${
                            !isEligible ? css.methodCardDisabled : ""
                          }`}
                          onClick={() => {
                            if (!isEligible) {
                              Swal.fire({
                                title: "Amount Outside Bank Limits",
                                text: `Bank transfers require ₹${minLimitBank} to ₹${maxLimitBank}.`,
                                icon: "info",
                                confirmButtonText: "OK",
                              });
                              return;
                            }
                            setType("banktransfer");
                            setNext(3);
                          }}
                        >
                          <div className={css.methodCardLeft}>
                            <div
                              className={`${css.methodIconWrap} ${css.bankIconStyle}`}
                            >
                              <RiBankLine />
                            </div>
                            <div className={css.methodInfo}>
                              <div className={css.methodName}>
                                Bank Transfer
                              </div>
                              <div className={css.methodDesc}>
                                Direct IMPS / NEFT to your bank account
                              </div>
                              <span className={css.methodLimitsPill}>
                                Limit: ₹{minLimitBank} - ₹{maxLimitBank}
                              </span>
                            </div>
                          </div>
                          <div className={css.methodCardArrow}>
                            <RiArrowRightSLine />
                          </div>
                        </div>
                      );
                    })()}

                  {/* Method 3: QR Code */}
                  {qrWithdrawal &&
                    (() => {
                      const isEligible =
                        parseFloat(withdrawAmount) >= minLimitQr &&
                        parseFloat(withdrawAmount) <= maxLimitQr;
                      return (
                        <div
                          className={`${css.methodCard} ${
                            !isEligible ? css.methodCardDisabled : ""
                          }`}
                          onClick={() => {
                            if (!isEligible) {
                              Swal.fire({
                                title: "Amount Outside QR Limits",
                                text: `QR withdrawals require ₹${minLimitQr} to ₹${maxLimitQr}.`,
                                icon: "info",
                                confirmButtonText: "OK",
                              });
                              return;
                            }
                            setType("qrcode");
                            setNext(3);
                          }}
                        >
                          <div className={css.methodCardLeft}>
                            <div
                              className={`${css.methodIconWrap} ${css.qrIconStyle}`}
                            >
                              <RiQrCodeLine />
                            </div>
                            <div className={css.methodInfo}>
                              <div className={css.methodName}>
                                QR Code Withdrawal
                              </div>
                              <div className={css.methodDesc}>
                                Upload your QR Code & get instant payout
                              </div>
                              <span className={css.methodLimitsPill}>
                                Limit: ₹{minLimitQr} - ₹{maxLimitQr}
                              </span>
                            </div>
                          </div>
                          <div className={css.methodCardArrow}>
                            <RiArrowRightSLine />
                          </div>
                        </div>
                      );
                    })()}
                </div>
              </div>
            )}

            {/* STEP 3: ACCOUNT DETAILS & FINAL CONFIRMATION */}
            {next === 3 && (
              <div className={css.cardBox}>
                {/* Selected Method Bar */}
                <div className={css.selectedMethodBar}>
                  <div className={css.selectedMethodLeft}>
                    <div
                      className={`${css.methodIconWrap} ${
                        type === "upi"
                          ? css.upiIconStyle
                          : type === "banktransfer"
                            ? css.bankIconStyle
                            : css.qrIconStyle
                      }`}
                      style={{
                        width: "38px",
                        height: "38px",
                        fontSize: "1.2rem",
                      }}
                    >
                      {type === "upi" ? (
                        <RiSmartphoneLine />
                      ) : type === "banktransfer" ? (
                        <RiBankLine />
                      ) : (
                        <RiQrCodeLine />
                      )}
                    </div>
                    <div>
                      <div className={css.selectedMethodTitle}>
                        {type === "upi"
                          ? "UPI Transfer"
                          : type === "banktransfer"
                            ? "Bank Transfer"
                            : "QR Code Withdrawal"}
                      </div>
                      <div className={css.selectedMethodSub}>
                        Payout Amount: <strong>₹{withdrawAmount}</strong>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className={css.btnEditMethod}
                    onClick={() => setNext(2)}
                  >
                    Change Method
                  </button>
                </div>

                {/* Form Fields: UPI */}
                {type === "upi" && (
                  <div>
                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        Account Holder Name
                      </label>
                      <div className={css.formInputWrapper}>
                        <RiUser3Line className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="Enter Account Name"
                          value={holder_name}
                          onChange={(e) => setHolder_name(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        UPI ID (e.g. mobile@upi, name@okaxis)
                      </label>
                      <div className={css.formInputWrapper}>
                        <RiSmartphoneLine className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="e.g. 9876543210@paytm"
                          value={upi_id}
                          onChange={(e) => setUpi_id(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>Confirm UPI ID</label>
                      <div className={css.formInputWrapper}>
                        <RiSmartphoneLine className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="Re-enter UPI ID"
                          value={confirm_upi_id}
                          onChange={(e) => setConfirm_upi_id(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Form Fields: Bank Transfer */}
                {type === "banktransfer" && (
                  <div>
                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        Account Holder Name
                      </label>
                      <div className={css.formInputWrapper}>
                        <RiUser3Line className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="Full Name as per Bank Account"
                          value={holder_name}
                          onChange={(e) => setHolder_name(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>Account Number</label>
                      <div className={css.formInputWrapper}>
                        <RiBankLine className={css.inputIcon} />
                        <input
                          type="number"
                          className={css.formInput}
                          placeholder="Enter bank account number"
                          value={account_number}
                          onChange={(e) => setAccount_number(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        Confirm Account Number
                      </label>
                      <div className={css.formInputWrapper}>
                        <RiBankLine className={css.inputIcon} />
                        <input
                          type="number"
                          className={css.formInput}
                          placeholder="Re-enter bank account number"
                          value={confirm_account_number}
                          onChange={(e) =>
                            setConfirm_account_number(e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>IFSC Code</label>
                      <div className={css.formInputWrapper}>
                        <RiBankLine className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="e.g. SBIN0001234"
                          value={ifsc_code}
                          onChange={handleIfscChange}
                          maxLength={11}
                          required
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Form Fields: QR Code */}
                {type === "qrcode" && (
                  <div>
                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        Account Holder Name
                      </label>
                      <div className={css.formInputWrapper}>
                        <RiUser3Line className={css.inputIcon} />
                        <input
                          type="text"
                          className={css.formInput}
                          placeholder="Enter Account Name"
                          value={holder_name}
                          onChange={(e) => setHolder_name(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className={css.formGroup}>
                      <label className={css.formLabel}>
                        Upload Your QR Code
                      </label>
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept="image/*"
                        onChange={handleQrUpload}
                        style={{ display: "none" }}
                      />

                      {qrPreview ? (
                        <div className={css.qrPreviewWrap}>
                          <img
                            src={qrPreview}
                            alt="QR Preview"
                            className={css.qrPreviewImg}
                          />
                          <button
                            type="button"
                            className={css.qrChangeBtn}
                            onClick={() =>
                              fileInputRef.current &&
                              fileInputRef.current.click()
                            }
                          >
                            <FiEdit3 className="mr-1" /> Change QR Image
                          </button>
                        </div>
                      ) : (
                        <div
                          className={css.qrUploadBox}
                          onClick={() =>
                            fileInputRef.current && fileInputRef.current.click()
                          }
                        >
                          <RiUploadCloud2Line className={css.qrUploadIcon} />
                          <div className={css.qrUploadText}>
                            Tap to Upload QR Code
                          </div>
                          <div className={css.qrUploadSub}>
                            Supports JPG, PNG or screenshot of your UPI QR
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Security Trust Pill */}
                <div className={css.securityPill}>
                  <BsShieldCheck />
                  <span>Verified 256-Bit Encrypted Instant Settlement</span>
                </div>

                {/* Submit Withdrawal Button */}
                <button
                  type="button"
                  className={css.btnSuccess}
                  disabled={!submitBtn || isLoading}
                  onClick={updateBankDetails}
                >
                  {isLoading ? (
                    <AppLoader size="sm" color="white" />
                  ) : (
                    <>
                      <span>Submit Withdrawal • ₹{withdrawAmount}</span>
                      <RiArrowRightSLine style={{ fontSize: "1.2rem" }} />
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Withdraw;
